import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input, MenuItem, Select as MaterialSelect, Stack, Typography, useTheme, } from '@mui/material';
export const Select = ({ options, value, onChange, label, disabled }) => {
    const theme = useTheme();
    return (_jsxs(Stack, { gap: "8px", flex: 1, children: [_jsx(Typography, { fontSize: "12px", fontWeight: 700, letterSpacing: "0.17px", color: theme.palette.text.primary, children: label }), _jsx(MaterialSelect, { value: value, disabled: disabled, variant: "standard", onChange: onChange, input: _jsx(Input, { disableUnderline: true }), sx: {
                    fontSize: '14px',
                    fontWeight: 400,
                    color: theme.palette.text.primary,
                }, children: options === null || options === void 0 ? void 0 : options.map((option, index) => (_jsx(MenuItem, { value: option, children: option }, index))) })] }));
};
